export var LabelPosition = {
  Before: 'before',
  After: 'after'
};